import { defineStore } from "pinia";
import { useGeneralStore } from "%/stores/general-store";
import { useMyExpertServicePackageFeedStore } from "@/smart-feed/stores/feed/my-expert-service-package-feed-store";

export const useExpertServicePackageStore = defineStore(
  "expert-service-package-store",
  {
    state: () => ({
      isLoadingCreateExpertPackage: false,
      isLoadingUpdateExpertPackage: false,
      isLoadingDisableExpertPackage: false,
      isLoadingEnableExpertPackage: false,
      isLoadingAddExpert: false,
      isLoadingRemoveExpert: false,
      expertPackageModalOpen: false,
      expertPackageModalMode: "create",
      currentExpertPackage: null,
      error: null,
      activeExpertIds: [],
      currentExpertiseId: null,
    }),

    getters: {
      orgId() {
        return useGeneralStore().orgId;
      },
    },

    actions: {
      openExpertPackageModal(mode = "create", expertPackage = null) {
        this.expertPackageModalMode = mode;
        this.currentExpertPackage = expertPackage;
        this.expertPackageModalOpen = true;
      },

      closeExpertPackageModal() {
        this.expertPackageModalOpen = false;
        this.currentExpertPackage = null;
      },

      createExpertPackage(
        orgId,
        name,
        description,
        price,
        onSuccess = () => {},
      ) {
        this.isLoadingCreateExpertPackage = true;
        this.error = null;

        this.apiPost(
          "/expert/package",
          {
            org_id: orgId,
            name,
            description,
            price,
          },
          () => {
            this.isLoadingCreateExpertPackage = false;
            useMyExpertServicePackageFeedStore().reload();
            this.closeExpertPackageModal();
            onSuccess();
          },
          error => {
            this.isLoadingCreateExpertPackage = false;
            this.error =
              error.response?.data?.message ||
              "Failed to create expert service package";
          },
        );
      },

      updateExpertPackage(
        expertPackageId,
        name,
        description,
        price,
        onSuccess = () => {},
      ) {
        this.isLoadingUpdateExpertPackage = true;
        this.error = null;

        this.apiPost(
          `/expert/package/${expertPackageId}`,
          {
            name,
            description,
            price,
          },
          () => {
            this.isLoadingUpdateExpertPackage = false;
            useMyExpertServicePackageFeedStore().reload();
            this.closeExpertPackageModal();
            onSuccess();
          },
          error => {
            this.isLoadingUpdateExpertPackage = false;
            this.error =
              error.response?.data?.message ||
              "Failed to update expert service package";
          },
        );
      },

      disableExpertPackage(expertPackageId, onSuccess = () => {}) {
        this.isLoadingDisableExpertPackage = true;
        this.error = null;

        this.apiPost(
          `/expert/package/${expertPackageId}/disable`,
          {},
          () => {
            this.isLoadingDisableExpertPackage = false;
            useMyExpertServicePackageFeedStore().reload();
            onSuccess();
          },
          error => {
            this.isLoadingDisableExpertPackage = false;
            this.error =
              error.response?.data?.message ||
              "Failed to disable expert service package";
          },
        );
      },

      enableExpertPackage(expertPackageId, onSuccess = () => {}) {
        this.isLoadingEnableExpertPackage = true;
        this.error = null;

        this.apiPost(
          `/expert/package/${expertPackageId}/enable`,
          {},
          () => {
            this.isLoadingEnableExpertPackage = false;
            useMyExpertServicePackageFeedStore().reload();
            onSuccess();
          },
          error => {
            this.isLoadingEnableExpertPackage = false;
            this.error =
              error.response?.data?.message ||
              "Failed to enable expert service package";
          },
        );
      },

      addOrgExpertise(orgId, expertId, onSuccess = () => {}, onError = () => {}) {
        this.isLoadingAddExpert = true;
        this.error = null;
        this.currentExpertiseId = expertId;

        this.apiPost(
          `/expert/${orgId}/add`,
          {
            expertise_id: expertId,
          },
          response => {
            this.isLoadingAddExpert = false;
            onSuccess(response.data);
            this.currentExpertiseId = null;
          },
          error => {
            this.isLoadingAddExpert = false;
            this.error =
              error.response?.data?.message || "Failed to add expert";
            onError(error);
            this.currentExpertiseId = null;
          },
        );
      },

      removeOrgExpertise(orgId, expertId, onSuccess = () => {}, onError = () => {}) {
        this.isLoadingRemoveExpert = true;
        this.error = null;
        this.currentExpertiseId = expertId;

        this.apiPost(
          `/expert/${orgId}/remove`,
          {
            expertise_id: expertId,
          },
          response => {
            this.isLoadingRemoveExpert = false;
            onSuccess(response.data);
            this.currentExpertiseId = null;
          },
          error => {
            this.isLoadingRemoveExpert = false;
            this.error =
              error.response?.data?.message || "Failed to remove expert";
            onError(error);
            this.currentExpertiseId = null;
          },
        );
      },
    },
  },
);
